module.exports = __webpack_public_path__ + "static/media/P03.47795af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panel_strobe/P03.png
// module id = 193
// module chunks = 0